// extracted by mini-css-extract-plugin
module.exports = {"locales":"LocaleSwitcher_locales__BmYDO","locale":"LocaleSwitcher_locale__mEZy9"};